import React from 'react';

export default function WhatsAppIntegration() {
  return (
    <div className="page">
      <header className="header"><h1>WhatsApp Integration</h1></header>
      <main className="container">
        <div className="panel">
          <p>Connect agents to WhatsApp conversations — coming soon.</p>
        </div>
      </main>
    </div>
  );
}

